module.exports = React;


/*****************
 ** WEBPACK FOOTER
 ** external "React"
 ** module id = 1
 ** module chunks = 0
 **/